'use client';

import type { PropsWithChildren } from 'react';

import {
	CalmTheme as ClassicTheme,
	DesignSystemProvider as OriginalDesignSystemProvider,
	SleepTheme,
} from '@calm-web/design-system';

import StyledComponentsRegistry from '@/components/layout/StyledComponentsRegistry';

export type DesignSystemProviderProps = PropsWithChildren<{
	theme?: typeof ClassicTheme | typeof SleepTheme;
}>;

const DesignSystemProvider = ({ children, theme = ClassicTheme }: DesignSystemProviderProps) => {
	return (
		<StyledComponentsRegistry>
			<OriginalDesignSystemProvider theme={theme}>{children}</OriginalDesignSystemProvider>
		</StyledComponentsRegistry>
	);
};

export default DesignSystemProvider;
